/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ConfigView = {
    name?: ConfigView.name;
    /**
     * String value; semantics depend on name (e.g. integer euro cents for price-related keys)
     */
    value?: string;
};
export namespace ConfigView {
    export enum name {
        CONTENT_MASTER_ON_DEMAND_PRICE_CENTS_PER_1000_TOKENS = 'content_master_on_demand_price_cents_per_1000_tokens',
        STRIPE_BILLING_THRESHOLD_CENTS = 'stripe_billing_threshold_cents',
        CONTENT_MASTER_BASE_TOKENS_GENERATE = 'content_master_base_tokens_generate',
        CONTENT_MASTER_BASE_TOKENS_TRANSLATE = 'content_master_base_tokens_translate',
        CONTENT_MASTER_BASE_TOKENS_CATEGORY_DETECT = 'content_master_base_tokens_category_detect',
        CONTENT_MASTER_TOKENS_PER_FIELD_GENERATE = 'content_master_tokens_per_field_generate',
        CONTENT_MASTER_TOKENS_PER_FIELD_TRANSLATE = 'content_master_tokens_per_field_translate',
        CONTENT_MASTER_TOKENS_PER_APPLY = 'content_master_tokens_per_apply',
        CONTENT_MASTER_TOKENS_PER_10K_CONTEXT_CHARS = 'content_master_tokens_per_10k_context_chars',
        CONTENT_MASTER_MODEL_TIER_1_MULTIPLIER = 'content_master_model_tier_1_multiplier',
        CONTENT_MASTER_MODEL_TIER_2_MULTIPLIER = 'content_master_model_tier_2_multiplier',
        CONTENT_MASTER_MODEL_TIER_3_MULTIPLIER = 'content_master_model_tier_3_multiplier',
        CONTENT_MASTER_TRIAL_TOKENS_PER_OPERATION = 'content_master_trial_tokens_per_operation',
        GOOGLE_REVIEW_SYNC_CALL_DELAY_MS = 'google_review_sync_call_delay_ms',
        MARKETPLACE_CATEGORY_TREE_SHORTLIST_MAX = 'marketplace_category_tree_shortlist_max',
        REPORT_RETENTION_MONTHS = 'report_retention_months',
    }
}

